import { createContext, useContext } from 'react';
import type { Column } from '../../types';

type ColumnContextType = Column & { isHeadColumn: boolean };

// @ts-expect-error Хук используется только внутри контекста, дефолты не нужны
export const ColumnContext = createContext<ColumnContextType>({});

export const useColumn = () => {
  return useContext(ColumnContext);
};
